module.exports = __webpack_public_path__ + "86df4aee193b3206906c572773d348d1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-10.png
// module id = 1590
// module chunks = 0